import script from "./Pencil.vue?vue&type=script&setup=true&lang=js"
export * from "./Pencil.vue?vue&type=script&setup=true&lang=js"

import "./Pencil.vue?vue&type=style&index=0&id=ce748a62&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce748a62"]])

export default __exports__